// extracted by mini-css-extract-plugin
export var body = "QuickLInksSupport-module--body--b5754";
export var contentWrapper = "QuickLInksSupport-module--contentWrapper--ba0ae";
export var footer = "QuickLInksSupport-module--footer--ca3cc";
export var heading = "QuickLInksSupport-module--heading--48616";
export var link = "QuickLInksSupport-module--link--53771";
export var title = "QuickLInksSupport-module--title--34ad2";